import styled from 'styled-components/macro';
import {  NavLink } from 'react-router-dom';
import { FONTS } from 'utils/styles/fonts';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';

export const NavItem = styled(NavLink)`
  color: ${COLORS.mainColor};
  ${FONTS.font18}
`;

export const StyledImage = styled.img``;

export const StyledFlexContainer = styled.div`
  ${FLEX_CONTAINER.FlexRow}
  column-gap: 24px;
`;
